module.exports = __webpack_public_path__ + "assets/img/1_1713_big.31697866.jpg";